<template>
  <footer class="footer-section">
    <div class="ta-center bg-blue support">
      <p v-html="$t('footer.mail')"></p>
    </div>
    <div class="bg-footer-custom footer-top pt-50 pb-5 banner-3-bg">
      <div class="container">
        <div class="row justify-content-between">
          <div class="col-lg-3 mb-3 mb-lg-0 alignCenter">
            <ul class="list-unstyled support-list footer-link">
              <li class="mb-4 d-flex ">
                <img
                  src="../assets/logo.png"
                  alt="Gupshup"
                  width="120"
                  class="img-fluid mb-3"
                />
              </li>
              <li class="mb-4 d-flex ">
                <i class="bi bi-geo-alt-fill mr-2"></i>
                <p class="mb-0" v-html="$t('footer.address')"></p>
              </li>
              <li class="mb-4 d-flex ">
                <i
                  class="bi bi-telephone-fill mr-2"
                  style="    position: relative;
    top: -1px;"
                ></i>
                <p class="mb-0" v-html="$t('footer.phone')"></p>
              </li>

              <li class="mb-2 d-flex">
                <i class="bi bi-envelope-fill mr-2"></i>
                <p class="mb-0" v-html="$t('footer.support')"></p>
              </li>
            </ul>
          </div>
          <div class="col-lg-2 ml-auto mb-4 mb-lg-0 alignCenter">
            <div class="footer-nav-wrap text-grey">
              <h5 class="mb-3 text-grey">
                {{ $t("footer.linkHead") }}
              </h5>
              <ul class="list-unstyled pl-0 fs10 center">
                <li class="mb-2">
                  <a href="https://support.gupshup.io/hc/en-us">{{
                    $t("footer.link1")
                  }}</a>
                </li>
                <li class="mb-2">
                  <a
                    href="https://support.gupshup.io/hc/en-us/categories/201183149-Chat-Bots"
                    >{{ $t("footer.link2") }}</a
                  >
                </li>
              </ul>
            </div>
          </div>
          <div
            class="col-lg-2 ml-auto mb-4 mb-lg-0 alignCenter"
            style="text-align:center"
          >
            <div class="footer-nav-wrap text-grey">
              <h5 class="mb-3 text-grey">
                {{ $t("footer.linkHead1") }}
              </h5>
              <ul class="list-unstyled pl-0 fs10 center">
                <li class="uppercase mb2">
                  <a href="https://support.gupshup.io/hc/en-us">{{
                    $t("header.t1")
                  }}</a>
                </li>
                <li class="uppercase mb2">
                  <a href="https://www.gupshup.io/developer/rcs">{{
                    $t("header.t2")
                  }}</a>
                </li>
                <li class="uppercase mb2">
                  <a href="https://www.gupshup.io/developer/messaging-api">{{
                    $t("header.t3")
                  }}</a>
                </li>
                <li class="uppercase mb2">
                  <a href="https://www.gupshup.io/developer/bot-platform">{{
                    $t("footer.link3")
                  }}</a>
                </li>
                <li class="uppercase mb2">
                  <a href="https://www.gupshup.io/developer/engagement-tools">{{
                    $t("footer.link4")
                  }}</a>
                </li>
              </ul>
            </div>
          </div>
          <div class="col-lg-2 ml-auto mb-4 mb-lg-0 alignCenter">
            <div class="footer-nav-wrap text-grey">
              <h5 class="mb-3 text-grey">
                {{ $t("footer.linkHead2") }}
              </h5>
              <ul class="list-unstyled pl-0 fs10 center">
                <li class="uppercase mb2">
                  <a href="https://www.gupshup.io/developer/ent-apis">{{
                    $t("footer.link5")
                  }}</a>
                </li>
                <li class="uppercase mb2">
                  <a
                    href="https://www.gupshup.io/developer/docs/bot-platform/guide/whatsapp-api-documentation"
                    >{{ $t("footer.link6") }}</a
                  >
                </li>
                <li class="uppercase mb2">
                  <a
                    href="https://stackoverflow.com/questions/tagged/gupshup"
                    >{{ $t("footer.link7") }}</a
                  >
                </li>
              </ul>
            </div>
          </div>

          <div class="col-lg-3 alignCenter">
            <div class="footer-nav-wrap text-grey">
              <p class="mb-3 text-grey fs-12 uppercase center">
                {{ $t("footer.subscribeHead") }}
              </p>
              <div class="ta-center">
                <input
                  type="text"
                  name="fullname"
                  v-bind:placeholder="$t('footer.inputName')"
                  required="required"
                  class="form-control footersubscribe bt-3"
                  v-model="subscriberName"
                />
                <input
                  type="email"
                  name="email"
                  v-bind:placeholder="$t('footer.inputEmail')"
                  required="required"
                  class="form-control footersubscribe bb-3"
                  v-model="subscriberEmail"
                />
                <a
                  href="#"
                  class="custombuttonsubscribe"
                  @click.prevent="handleSubscribe"
                >
                  {{ $t("footer.subscribe") }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom pt-4">
        <div class="container" style="border-top: solid white 2px">
          <div class="row">
            <ul style="padding-left: 0px">
              <li class="floatleft">
                <a href="https://www.gupshup.io/developer/about">{{
                  $t("footer.link8")
                }}</a>
              </li>
              <li class="floatleft">
                <a href="https://www.gupshup.io/developer/contactus">{{
                  $t("footer.link9")
                }}</a>
              </li>
              <li class="floatleft">
                <a href="https://www.gupshup.io/developer/press">{{
                  $t("footer.link10")
                }}</a>
              </li>
              <li class="floatleft">
                <a href="https://www.gupshup.io/webinars">{{
                  $t("footer.link11")
                }}</a>
              </li>
              <li class="floatleft">
                <a href="https://www.gupshup.io/developer/privacy">{{
                  $t("footer.link12")
                }}</a>
              </li>
              <li class="floatleft">
                <a href="https://www.gupshup.io/developer/terms">{{
                  $t("footer.link13")
                }}</a>
              </li>
              <li class="floatleft">
                <a href="https://blog.gupshup.io/">{{ $t("footer.link14") }}</a>
              </li>
            </ul>
          </div>
          <div class="row">
            <div class="col-md-6 col-lg-5">
              <p class="copyright-text pb-0 mb-0 colorWhite center">
                {{ $t("common.footer.copyright") }}
              </p>
            </div>
            <div class="social-list-wrap col-md-6 alignCenter">
              <ul class="social-list list-inline list-unstyled floatRight pl-0">
                <li class="floatleft">
                  <a
                    href="https://www.facebook.com/gupshupbots"
                    target="_blank"
                    class="width30"
                    title="Facebook"
                    ><img src="../assets/background/facebook.png" />
                  </a>
                </li>
                <li class="floatleft">
                  <a
                    href="https://twitter.com/gupshup"
                    target="_blank"
                    class="width30"
                    title="Twitter"
                    ><img src="../assets/background/twitter.png" />
                  </a>
                </li>
                <li class="floatleft">
                  <a
                    href="https://www.linkedin.com/company/gupshup/"
                    target="_blank"
                    class="width30"
                    title="Linkedin"
                    ><img src="../assets/background/linkedin.png"
                  /></a>
                </li>
                <li class="floatleft">
                  <a
                    href="https://medium.com/@gupshup"
                    target="_blank"
                    class="width30"
                    title="Medium"
                    ><img src="../assets/background/medium.png"
                  /></a>
                </li>
                <!-- <li class="floatleft">
                  <span class="width30"><selectLocale /></span>
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import i18n from "../i18n";
export default {
  name: "Footer",
  data() {
    return {
      subscriberName: "",
      subscriberEmail: "",
    };
  },
  methods: {
    handleSubscribe() {
      if (this.subscriberName && this.subscriberEmail) {
        // alert(`Hi ${this.subscriberName}, You subscribed successfully !`);
        alert(
          i18n.t("alertText.subSuccessfull", { form: this.subscriberName })
        );
      } else {
        // alert(`Kindly add subscriber's details.`);
        alert(i18n.t("alertText.subDetailNeeded"));
      }
    },
  },
};
</script>

<!--------------------------->

<style lang="scss">
.text-grey {
  color: #b1c0cc;
}
.uppercase {
  text-transform: uppercase;
}
.mb2 {
  margin-bottom: 2px;
}
.colorWhite {
  color: #b1c0cc;
}
.support {
  p {
    color: white;
    margin-bottom: 0px;
    a {
      color: white;
    }
  }
}
.footer-section .bg-footer-custom {
  a {
    color: #b1c0cc;
    font-size: 10px;
  }
  li,
  p,
  .footer-nav-wrap li {
    color: #b1c0cc;
    font-size: 10px;
  }
}
.footer-nav-wrap ul li a {
  font-size: 12px;
}
.footer-nav-wrap {
  .footersubscribe {
    color: #fff;
    background-color: transparent;
    padding: 7px;
    height: auto;
    margin-top: 0px;
    border: #6c6868 1px solid;
  }
  .bt-3 {
    border-radius: 3px 3px 0px 0px;
  }
  .bb-3 {
    border-radius: 0px 0px 3px 3px;
  }
  input[type="text"] {
    margin-bottom: 0px;
  }
}
.footer-nav-wrap {
  ::-webkit-input-placeholder {
    font-style: italic;
  }
  :-moz-placeholder {
    font-style: italic;
  }
  ::-moz-placeholder {
    font-style: italic;
  }
  :-ms-input-placeholder {
    font-style: italic;
  }
}
.footer-section .bg-footer-custom a.custombuttonsubscribe {
  color: white;
}
@media (min-width: 320px) and (max-width: 960px) {
  .alignCenter {
    margin: auto;
    display: flex;
    justify-content: center;
    .center {
      text-align: center;
    }
  }
  .center {
    text-align: center;
  }
  .pl-0 {
    padding-left: 0px;
  }
  .width30 {
    width: 30px;
  }
}
@media (min-width: 960px) {
  .floatRight {
    float: right;
  }
  .width30 {
    width: 30px;
  }
}
</style>
